<template>
  <div :class="['spinner', { 'no-animation': !isShowAnimation }]">
    <div class="dot1"></div>
    <div class="dot2"></div>
    <div class="dot3"></div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, ref } from 'vue';
const isShowAnimation = ref(true);
onBeforeUnmount(() => {
  isShowAnimation.value = false;
});
</script>

<style scoped lang="less">
@import './qf-dot-animation.less';
</style>
